
define('PlaceModel',['underscore','jquery','backbone','app','router','ObjectModel','LocalStorage','ApiRequest','prototypes/onQuotaExceededError','string'],
    function (_,$,Backbone,app,router,ObjectModel,LocalStorage,ApiRequest,onQuotaExceededError,S) {

    var placesService,
        PLACE_MODEL_NAME = 'PlaceModel';

    var localitySecondary, localityPrimary, localityDescriptionEnd;

    // distance kilometrique entre 2 latitude
    //
    function DistanceKm(lat1,lng1,lat2,lng2) {
      var p = 0.017453292519943295,    // Math.PI / 180
          c = Math.cos,
          a = 0.5 - c((lat2 - lat1) * p)/2 +
              c(lat1 * p) * c(lat2 * p) *
              (1 - c((lng2 - lng1) * p))/2;

      return 12742 * Math.asin(Math.sqrt(a)); // 2 * R; R = 6371 km
    }

    var PlaceModelPrototype = {
        name:PLACE_MODEL_NAME,
        idAttribute:'place_id',
        route:'apiPlaceModel',
        translated:false,

        defaults:{
            trust:false,
            isSync:false,
            no_alternative:false,
            base64address:''
        },

        initialize:function(){
            var place = this;
            // ObjectCollection constructor heritage
            ObjectModel.prototype.initialize.apply(place);
            place.storeDistances = {};
            place.softFetch();
            if(!place.get('types')){place.set('types',[])}
            place.on('error',function(){
            });
            //
            place.updateBase64Address();
            place.on('change:delay_max_vad',place.onChangeDelay);
            place.on('change',place.onChange);
            place.on('sync',place.onPlaceSync);
            place.on('error',place.onError);
            place.on('QuotaExceededError',onQuotaExceededError);
            if(/^fallback_place_/.test(place.id)){
                // si la place est issue du formulaire secondaire de saisie d'adresse
                // on converti le "postcode" en "postal_code"
                place.set({
                    postal_code:place.get('postcode')
                })
            }
        },

        remoteFetch:function(){
            var place = this;
            // prévient les chargements récursifs en cas d'erreur.
            if(!place.get('no_alternative')){
                LocalStorage.remoteFetch.apply(place,arguments);
            }else{
                place.trigger('error',place);
            }
        },

        updateBase64Address:function(){
            // met à jour la description encodé en base 64
            var place = this,
                description = place.getDescription();
            if(description){
                place.set({base64address:description},{silent:true});
            }else if(!/^address_\d+/.test(place.id)){
                app.error('Invalid place description',{
                    cart:app.getCart().toJSON(),
                    place:place.toJSON()
                });
            }
        },

        onChange:function(){
            //this.updateLocalStorageItem();
        },

        onPlaceSync:function(){
            this.updateBase64Address();
            this.set('isSync',true);
        },

        isSync:function(){return this.get('isSync')},
        isGooglePlace:function(){
            // test si l'identifiant n'est celui pour signifier une adresse manuelle
            var id = this.get('place_id');
            return id && id.length > 0 && !/^id_district|unknown|^fallback_place_/.test(id);
        },

        getDelays:function(){
            return this.pick('delay_max_vad','delay_min_vad','delay_max_vae','delay_min_vae');
        },

        isLocalityMatching:function(){
            //
            // vérifie la localité
            // si la localité existe parmis les codes postaux
            //
            var model = this,locality,
                isLocalityMatching = false;
            //
            if(isLocalityMatching = model.get('isLocalityMatching')) return isLocalityMatching;
            //
            var placeLocalityMatching = app.c('_PLACE_LOCALITY_MATCHING_','ignore');
            if(placeLocalityMatching == 'ignore'){
                // ignore le matching locality, attention, cela nuit gravement aux performances
                return true;
            }
            //
            locality = model.getLocality();
            if(locality){
                isLocalityMatching = app.getPostcodes().isLocalityMatching(locality);
            }else{
                // sinon on essaie quand même d'avoir plus d'info via l’API Place
                isLocalityMatching = true;
            }
            model.set('isLocalityMatching',isLocalityMatching);
            return isLocalityMatching;
        },

        onError:function(place,response,request){
           if(response && response.responseJSON && response.responseJSON.token){
               place.token = response.responseJSON.token;
               if(app.c('_GOOGLE_PLACE_API_LOCKED_',1)!=1){
                   place.alternativeFetch();
               }else{
                   place.noAlternative();
               }
           }
        },

        noAlternative:function(){
            // trigger when fetch fail, with no alternative
            var place = this;
            place.set('no_alternative',true);
            app.error('PlaceModel noAlternative',place.toJSON());
            place.trigger('sync',place);
        },

        alternativeFetch:function(){
            var place = this;
            try {
                if (!placesService) {
                    placesService = new google.maps.places.PlacesService(document.createElement('div'));
                }
                app.error('PlaceModel alternativeFetch',place.toJSON());
                placesService.getDetails({placeId:place.get('place_id')},$.proxy(place.onAlternativeSync,place));
            }catch (e) {
                place.noAlternative();
            }
        },

        onAlternativeSync:function(results,status){
            var place = this,
                datas = {};
            if(status == 'OK'){
                if(results.geometry){
                    var g = results.geometry;
                    if(g.location){
                        var location = g.location;
                        datas.lat = location.lat();
                        datas.lng = location.lng();
                        results.geometry = {
                            lat:datas.lat,
                            lng:datas.lng
                        };
                    }
                }
                _(results.address_components).each(function(v,k){
                    _(['postal_code','locality','route','street_number','country']).each(function(componentKey){
                        if(_(v.types).contains(componentKey)){
                            datas[componentKey] = v.long_name;
                        }
                    });
                });
                var options = {
                    result : {r:JSON.stringify(results)},
                    token:place.token
                };
                ApiRequest('PlaceModel',options,place.attributes)
                    .done(function(data){
                        place.set(data);
                        place.trigger('sync',place);
                    }).fail(function(){
                        app.error('PlaceModelError',options);
                })
            }else{
                place.noAlternative();
            }
        },

        fillLatLngFromGeometry:function(){
            //
            // utilisé dans le cas où la synchronisation du placeId a lieu via le SDK JS de Google
            //
          var place = this,
              geometry = place.get('geometry'),
              location;
          if(geometry && (location = geometry.location)){
              place.set({
                  lat:location.lat(),
                  lng:location.lng()
              })
          }
        },

        getDescription:function(){
            var description = this.get('description');
            description = (description && description.length>0) ? description : false;
            return description || this.get('formatted_address') || false;
        },

        getLocality:function(){
            var model = this, locality = model.get('locality');
            if(locality) return locality;

            var secondary_text, main_text, localityExec,
                structured_formatting = model.get('structured_formatting');
            initLocalityRegExp();
            if(structured_formatting && structured_formatting.secondary_text){
                secondary_text = structured_formatting.secondary_text;
                main_text = structured_formatting.main_text;
                localityExec = localitySecondary.exec(secondary_text);
            }
            if(localityExec){
                locality = localityExec[1];
            }else if(main_text){
                locality = localityPrimary.exec(main_text)[1];
            }
            if(_.isUndefined(locality)){
                locality = model.get('city');
                var localityDescription = localityDescriptionEnd.exec(model.getDescription());
                if(!locality && localityDescription){
                    // 20 Rue de Madrid, Sainte-Luce-sur-Loire, France
                    // 20 Rue de Madrid, Saint-Acheul, Amiens, France
                    locality = localityDescription[1];
                }
            }
            if(!_.isUndefined(locality)){
                model.set('locality',locality);
            }
            return locality;
        },

        getPostalCode:function(){
            return this.get('postal_code')
        },

        getPostcode:function(){
            var model = this,
                id_postcode = model.get('id_postcode'),
                postcode = app.getPostcode(id_postcode);
            //


            //
            if(!postcode){
                // DEPRECATED LEGACY ASSOCIATION METHOD
                // locality = model.getLocality();
                // lat = model.getLat();
                // lng = model.getLng();
                //
                // var associationMode = app.c('_PLACE_ID_POSTCODE_ASSOCIATION_MODE_','postal_code_first');
                // if(associationMode == 'geocode_first'){
                //     // attention cette méthode retourne le premier résultat valide
                //     postcode = app.getPostcodes().getByLatLng(lat,lng);
                // }
                // if(!postcode){
                //     // approximation via la donnée postal_code
                //     postcode = app.getPostcodeByValue(postcode_value);
                // }
                //
                // if(!postcode) {
                //     // approximation par localité
                //     postcodes = app.getPostcodes().filterByLocalityName(locality);
                //     switch (postcodes.length) {
                //         case 0 :
                //             break; // cas où aucun code postal ne match
                //         case 1 : // cas ou un seul code postal matche avec le nom
                //             postcode = postcodes[0];
                //             break;
                //         default: // cas ou plusieurs code postaux match
                //             _(postcodes).each(function (postcodeModel) {
                //                 var district = postcodeModel.getLocationDistrict(lat, lng);
                //                 if (!_.isUndefined(district)) {
                //                     postcode = postcodeModel;
                //                 }
                //             });
                //     }
                // }
            }
            //
            return postcode;
        },
        // getPostcodeValue:function(){
        //     var p = this.getPostcode();
        //     return p ? p.getPostcode() : '';
        // },

        getDistrict:function(){
            var model = this,
                postcode = model.getPostcode(),
                district = postcode ? postcode.getDistrict(model.get('id_district')) : false;
            if(district){
                return district;
            }
            if(postcode){
                return postcode.getLocationDistrict(model.getLat(),model.getLng());
            }
        },
        getDistrictId:function(){
            var d = this.getDistrict();
            if(d) return d.id_district;
        },

        tryDistrict:function(){
            // méthode qui essaie de trouver le district si le serveur n'y arrive pas…
            var place = this, district = place.getDistrict(),
                postcode = place.getPostcode();
            if(district) return district;
            if(postcode){
                district = postcode.getLocationDistrict(place.getLat(),place.getLng());
            }
            if(district){
                place.set('id_district',district.id_district);
                return district;
            }
        },

        getLatLng:function(){
            var lat = this.getLat(),
                lng = this.getLng();
            if(lat && lng){return {
                lat:lat,
                lng:lng
            }}else{
                return false;
            }
        },
        getLat:function(){
            return parseFloat(this.get('lat'));
        },
        getLng:function(){
            return parseFloat(this.get('lng'));
        },

        getStores:function(datetime){
            var model = this,
                stores = [],
                postcode = model.getPostcode(),
                id_district = model.getDistrictId();

            if(postcode){
                stores = app.getStores().findByPostcode({
                    id_postcode:postcode.id,
                    id_district:id_district
                },datetime);
                if(!(stores.length>0)){
                    stores = [];
                }else if(stores.length == 1){
                }
            }else{
            }
            //
            // recherche alternative pour certains place_id,
            // on utilise une approximation par distance
            //
            if(model.isStoreDistanceApproximationAvailable()){
                //
                //
                var latLng = model.getLatLng(),
                    distanceStores = [];
                if(latLng){
                    app.getStores().each(function(store){
                        var distance = DistanceKm(latLng.lat,latLng.lng,store.getLatitude(),store.getLongitude());
                        //
                        // TODO static 25 km radius
                        if(distance<25){
                            distanceStores.push(store);
                            store._distance = model.storeDistances[store.id] = distance;
                        }
                    });
                    // on les tries par distance
                    distanceStores = _(distanceStores).sortBy('_distance');
                    // on ajoute les boutiques si elles ne préexistent pas (via postcode)
                    stores = _(stores).union(distanceStores);
                }else if(model.isSync()){
                    // si on est sur une place qui n'a pas de données, on essaie de fetcher, pour avoir
                    //model.fetch();
                }
            }
            //
            return _(stores);
        },
        //
        parseAddressComponents:function(){
            var model = this,
                typesMap = _(['street_number','route','country','locality','postal_code']),
                s = {};
            _(model.get('address_components')).each(function(comp){
                var firstType = comp.types[0];
                if(typesMap.contains(firstType)){
                    s[firstType] = comp.long_name;
                }
            });
            model.set(s);
        },
        // Données  Googles
        getCountry:function(){
            return this.get('country');
        },
        getStreet:function(){
            return this.get('route');
        },
        getStreetNumber:function(){
            return this.get('street_number');
        },
        getTypes:function(){
            // données Google | street_address | route | locality | sublocality | ...
            // voir https://developers.google.com/places/supported_types?hl=fr#table2
            return this.get('types')
        },
        isType:function(type){
            return _(this.getTypes()).contains(type)
        },
        isStreetAddress:function(){
            return this.isType('street_address');
        },
        isStoreDistanceApproximationAvailable:function(){
            // si on est sur une localité, on ajoute une approximation par distance
            return this.isType('locality');
        },

        // retourne un objet préformaté avec toutes les options pour créer une adresse
        getCartOptions:function(){
            var place = this,
                postcode = place.getPostcode(),
                postal_code = place.get('postal_code'),
                id_district = place.getDistrictId(),
                optionsMap = {
                    alias: place.get('alias') || '', // address alias
                    type: place.get('type') || 0, // address type (icon)
                    description: place.getDescription(),
                    street: place.getStreet(),
                    latitude:place.getLat(),
                    longitude:place.getLng(),
                    city: place.getLocality(),
                    country: place.getCountry(),
                    number: place.getStreetNumber(),
                    place_id: place.id,
            };
            if(postal_code){
                // si on a un postal_code il est utilisé
                optionsMap.postcode = postal_code;
            }else if(postcode){
                // sinon, si on a un postcode, on utilise sa valeur
                optionsMap.postcode = postcode.getPostcode();
            }
            if(postcode){
                optionsMap.id_postcode = postcode.id;
            }
            if (id_district) {
                optionsMap.id_district = id_district;
            }
            return optionsMap;
        }
    };

    var PlaceModel = ObjectModel
        .extend(LocalStorage)
        .extend(PlaceModelPrototype),
        places = new Backbone.Collection();

    // static getter
    PlaceModel.getPlace = function(place_id,originModel){
        //
        // originModel est une base pour afficher des données
        //
        if(!place_id) return;
        //
        var place = places.findWhere({place_id:place_id});
        //
        //
        if(!place){
            var options = {place_id:place_id};
            if(originModel){
                options = originModel.pick('place_id','description','id_postcode','id_district','locality','city','postcode','postal_code','types');
            }
            place = new PlaceModel(options);
            places.push(place);
        }
        return place;
    };


    function initLocalityRegExp(){
        //
        // initialise les expressions régulières
        //
        if(!localitySecondary){
            var gExpPrimary = app.c('_GOOGLE_ADDRESS_REG_EXP_PRIMARY_','(.*),?');
            var gExpSecondary = app.c('_GOOGLE_ADDRESS_REG_EXP_SECONDARY_','^(.*),');
            var gExpDescriptionEnd = app.c('_GOOGLE_ADDRESS_REG_EXP_DESCRIPTIONEND_','^.*, (.*), .*|.*, .*, (.*), .*$');
            localitySecondary = new RegExp(gExpPrimary), // city is the first item of secondary_text
            localityPrimary = new RegExp(gExpSecondary);
            localityDescriptionEnd = new RegExp(gExpDescriptionEnd);

        }
    };

    PlaceModel.removeAllItems = function () {
        places = new Backbone.Collection();
        LocalStorage.removeAllItemsOfType(PLACE_MODEL_NAME);
    };
    PlaceModel.resetAllDelays = function(){
        var unsetAttributes = _(["delay_max_vae","delay_min_vae","delay_max_vad","delay_min_vad"]),
            exp = new RegExp('^'+PLACE_MODEL_NAME+'_[A-Z]{2}_(.*)$'),
            expire = new RegExp('^'+PLACE_MODEL_NAME+'_[A-Z]{2}_(.*)_expires$');
        //
        try {
            for (var i = 0; i < LocalStorage.ls.length; i++) {
                var key = LocalStorage.ls.key(i);
                if (exp.test(key) && !expire.test(key)) {
                    var place = PlaceModel.getPlace(exp.exec(key)[1]);
                    if (!place.getDescription()) {
                        place.resetLocalStorageItem();

                        places = new Backbone.Collection(places.without(place));
                    } else {
                        unsetAttributes.each(function (attr) {
                            place.unset(attr);
                        });
                        place.updateLocalStorageItem();
                    }

                }
            }
        }catch(err){
        }
    };

    return PlaceModel;
});
